import { api, ApiError } from './api.js';
import { useOutbox } from './outbox-store.js';
import { toast } from './toast-store.js';

let running = false;

/** Network (status 0) or 5xx → worth retrying. 4xx (validation, ORDERS_READONLY 403) → give up. */
function retryable(err: unknown): boolean {
  if (err instanceof ApiError) return err.status === 0 || err.status >= 500;
  return true;
}

export async function drainOutbox(): Promise<void> {
  if (running) return;
  running = true;
  try {
    for (const o of useOutbox.getState().orders) {
      try {
        const order = await api.salesOrders.create(
          {
            customerNo: o.customerNo,
            customerPO: o.customerPO,
            requiredDate: o.requiredDate,
            type: o.type,
            shipTo: o.shipTo,
            notes: o.notes,
            items: o.items,
          },
          o.id, // stable idempotency key — Spire dedupes across retries
        );
        useOutbox.getState().remove(o.id);
        toast(`Order ${order.orderNo} sent`, 'success');
      } catch (err) {
        if (retryable(err)) {
          useOutbox.getState().setError(o.id, err instanceof Error ? err.message : 'send failed');
          break; // stop; the next online/interval tick tries again
        }
        useOutbox.getState().remove(o.id);
        toast(
          `Queued order for ${o.customerName} rejected: ${err instanceof Error ? err.message : 'error'}`,
          'error',
        );
      }
    }
  } finally {
    running = false;
  }
}

export function startOutboxProcessor(): void {
  window.addEventListener('online', () => void drainOutbox());
  window.setInterval(() => {
    if (useOutbox.getState().orders.length > 0) void drainOutbox();
  }, 30_000);
  void drainOutbox();
}
